import "../index.css"; // ✅ Load local styles first
import React from "react";
import { Link } from "react-router-dom";

const SurveyLandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white flex flex-col items-center justify-center px-6 py-12">
      {/* Hero Section */}
      
      <div className="text-center max-w-3xl">
        <h1 className="text-5xl font-extrabold bg-gradient-to-r from-green-400 via-blue-500 to-purple-500 text-transparent bg-clip-text drop-shadow-lg">
          Smart Pathways: From Messages to Media
        </h1>
        <p className="text-lg text-gray-300 mt-4">
          Transform your audience engagement with go2survey.link - where seamless survey links build trust and deliver actionable insights from their text inbox with mobile in mind.
        </p>
        <div className="mt-6 flex gap-4 justify-center">
          <a
            href="https://mobile.digital/contact"
            className="px-6 py-3 rounded-lg text-lg font-semibold bg-green-500 hover:bg-green-600 transition-all shadow-lg"
          >
            Get Started
          </a>
          <a
             href="https://mobile.digital/contact"
            className="px-6 py-3 rounded-lg text-lg font-semibold bg-gray-800 hover:bg-gray-700 border border-gray-600 transition-all shadow-lg"
          >
            Request Demo
          </a>
        </div>
      </div>

      {/* Features Section */}
      <div className="mt-16 max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="p-6 bg-gray-900 rounded-lg shadow-lg text-center">
          <h3 className="text-2xl font-bold text-green-400">Seamless Integration</h3>
          <p className="text-gray-400 mt-2">
            Connect messaging platforms directly to customized surveys, creating a frictionless experience.
          </p>
        </div>
        <div className="p-6 bg-gray-900 rounded-lg shadow-lg text-center">
          <h3 className="text-2xl font-bold text-blue-400">Trust Building</h3>
          <p className="text-gray-400 mt-2">
            Trackable links provide transparency and security, increasing respondent confidence.
          </p>
        </div>
        <div className="p-6 bg-gray-900 rounded-lg shadow-lg text-center">
          <h3 className="text-2xl font-bold text-purple-400">Higher Response Rates</h3>
          <p className="text-gray-400 mt-2">
            A user-friendly experience removes barriers, improving survey completion rates.
          </p>
        </div>
      </div>

      {/* How It Works */}
      <div className="mt-16 max-w-5xl text-center">
        <h2 className="text-3xl font-bold text-white">How It Works</h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-4 gap-6 text-white">
          <div className="p-4 bg-gray-800 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold">1. Create</h3>
            <p className="text-gray-400 mt-2">Build your custom survey with an intuitive design tool.</p>
          </div>
          <div className="p-4 bg-gray-800 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold">2. Generate</h3>
            <p className="text-gray-400 mt-2">Create branded short links that inspire confidence.</p>
          </div>
          <div className="p-4 bg-gray-800 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold">3. Distribute</h3>
            <p className="text-gray-400 mt-2">Share links via text, email, or social media.</p>
          </div>
          <div className="p-4 bg-gray-800 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold">4. Track</h3>
            <p className="text-gray-400 mt-2">Monitor responses in real-time with analytics.</p>
          </div>
        </div>
      </div>

      {/* Success Stories */}
      <div className="mt-16 max-w-5xl">
        <h2 className="text-3xl font-bold text-white text-center">Success Stories</h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
          <div className="p-6 bg-gray-900 rounded-lg shadow-lg text-center">
            <h3 className="text-xl font-bold text-green-400">Retail Insights</h3>
            <p className="text-gray-400 mt-2">Survey completion rates increased by 67% in two months.</p>
          </div>
          <div className="p-6 bg-gray-900 rounded-lg shadow-lg text-center">
            <h3 className="text-xl font-bold text-blue-400">Health Research</h3>
            <p className="text-gray-400 mt-2">98% delivery confirmation for sensitive health surveys.</p>
          </div>
          <div className="p-6 bg-gray-900 rounded-lg shadow-lg text-center">
            <h3 className="text-xl font-bold text-purple-400">Educational Surveys</h3>
            <p className="text-gray-400 mt-2">Survey completions tripled with fewer reminders.</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-16 text-sm text-gray-400 text-center">
        <p>Ready to elevate your surveys?</p>
        <a href="https://mobile.digital/contact" className="text-green-400 hover:text-green-500 transition">
          Contact Us
        </a>
        <p className="mt-2">© {new Date().getFullYear()} go2survey.link | All Rights Reserved</p>
      </footer>
    </div>
  );
};

export default SurveyLandingPage;
